import React, { useRef, useEffect, useCallback, useState} from 'react';
import {isMobile} from 'react-device-detect';
import {
    setSelectedPianoRollSteps,
    mouseDown
} from 'actions/index.js';
import Resolution from 'engine/Resolution.js';
import {toggleStep} from 'operations/actions.js';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';

const BASE_RESOLUTION = new Resolution(32, false);

const DOUBLE_CLICK_TIME = 250;
const colors = new Colors();

const StepToggle = ({
    track,
    color,
    on,
    stepNumber,
    resolution,
    stepData,
    trackStep,
    isCurrentStep,
    selectedPianoRollSteps=[],
    setSelectedSteps,
    cirklonMode,
    mouseDown,
    plocked,
    isSelected
}) => { 
    const lastClick = useRef(0);

    const onMouseOver = useCallback((e) => {
        if (isMobile) {
            return;
        }
        let isMouseDown= track.sequencerEngine.state.keyboard.isMouseDown;
        if (isMouseDown) {
            if ((e.ctrlKey || e.metaKey) && on) {
                selectStep(stepData);
            } else if (!e.metaKey && !e.ctrlKey) {
                toggle();
            }
        }
    }, [
        isSelected,
        track,
        cirklonMode,
        on,
        resolution,
        stepNumber,
        selectedPianoRollSteps]);

    const onClick = useCallback((isTouch, e) => {
        if (!isTouch && isMobile) {
            return;
        }
        mouseDown(true);
        // todo: check if in gang/slope mode, if so then select the
        // steps instead of togglin
        if ((e.metaKey || e.ctrlKey) && on) {
            e.stopPropagation();
            selectStep(stepData);
        } else if (!e.metaKey && !e.ctrlKey) {
            e.stopPropagation();
            toggle();
        }
    }, [
        stepNumber,
        stepData,
        track,
        cirklonMode,
        selectedPianoRollSteps,
        isSelected,
        on,
        resolution]); 

    const toggle = useCallback(() => {
        track.pattern.clearCache();
        track.sequencerEngine.cursor.setStep(stepNumber, resolution);
        track.sequencerEngine.operationManager.dispatch(
            toggleStep(track, stepNumber, resolution));
    }, [track, stepNumber, resolution]);

    const selectStep = useCallback((step) => {
        if (isSelected) {
            // unselect cuz its already selected
            let i = selectedPianoRollSteps.indexOf(stepData);
            selectedPianoRollSteps.splice(i, 1);
            setSelectedSteps([... selectedPianoRollSteps]);
        } else {
            setSelectedSteps([... selectedPianoRollSteps, stepData]);
        }
    }, [isSelected, selectedPianoRollSteps, setSelectedSteps, stepData]);

    let className = "step-toggle";
    let style = {};
    let innerStyle = {};
    
    if (on) {
        className += " on";
        style.backgroundColor = colors.transparent(colors.saturate(color, 1), 0.7);
        innerStyle.backgroundColor = color;
    }

    let tickStyle = {};
    if (isSelected) {
        style.backgroundColor = innerStyle.backgroundColor;
        innerStyle.color = innerStyle.backgroundColor;
        tickStyle.backgroundColor = innerStyle.backgroundColor;
        innerStyle.backgroundColor = null;
        
    }

    if (isCurrentStep) {
        className += " current";
    }

    if (isSelected) {
        className += " selected";
    }

    if (plocked) {
        className += " p-locked";
    }
    return (
        <div
          data-stepNumber={stepNumber}
          style={style}
          onContextMenu={e => {
              e.preventDefault();
              e.stopPropagation();
          }}
          onMouseOver={onMouseOver}
          onMouseDown={(e) => {
              e.stopPropagation();
              onClick(false, e);
          }}
          onTouchStart={(e) => onClick(true, e)}
          className={className}>
          <div style={innerStyle} className="step-inner">
            {plocked ? <div className="p-lock-indicator">
                         <div className="inner-indicator" style={isSelected ? style : innerStyle}/>
                       </div> : ''}
            {stepNumber + 1}
            <div style={tickStyle} className="step-bottom-tick"/>
          </div>
          </div>);

}

const mapStateToProps = (state, props) => {
    let resolution = state.sequencer.displayResolution;
    let trackStep = props.track.sequencerEngine.trackStep;
    let patternStep = Math.floor(resolution.transformStepAtResolution2(
        props.track.getPatternStep(trackStep),
        BASE_RESOLUTION));
    if (!props.stepData || !props.stepData.trackData) {
        return {};
    }
    return {
        resolution,
        isCurrentStep: patternStep === props.stepNumber,
        selectedPianoRollSteps: state.keyboard.selectedPianoRollSteps,
        cirklonMode: state.cirklon.cirklonMode[props.track.id],
        slice: props.stepData.slice,
        plocked: props.stepData.pLockedParameters.length 
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setSelectedSteps: (steps) =>
            dispatch(setSelectedPianoRollSteps(steps)),
        mouseDown: (m) =>
            dispatch(mouseDown(m)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepToggle);
